import React from "react"
import autobind from "class-autobind"
import moment from "moment"
import { RaisedButton, IconButton, FontIcon } from "material-ui"
import strings from "../../../localization/strings"
import * as timeHelper from "../../../helpers/timeHelper"
import { IDate, EDayOfWeek, ActiveTimeButton, TimeBarViewType } from "../../../models"
import { blueGrey500 } from "material-ui/styles/colors"
import FinddDatePicker from "../FinddDatePicker"
interface IProps {
  referenceDate: IDate
  startDayOfWeek: EDayOfWeek
  timeBarViewType: TimeBarViewType
  hideLastThisNextButton?: boolean
  handleChangeTimeRange(startDate: string, endDate: string): void
}
interface IState {
  referenceDate: IDate
}
const styles = {
  btn: { background: "white" },
  label: { fontSize: "14px", whiteSpace: "nowrap" },
  activeBtn: { background: "#A9A9A9" },
  activeLabel: { color: "white", whiteSpace: "nowrap" }
}

export default class TimeActionBar extends React.Component<IProps, IState> {
  private FinddDatePicker
  constructor(props) {
    super(props)
    this.state = {
      referenceDate: props.referenceDate,
    }
    autobind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.timeBarViewType === nextProps.timeBarViewType) return
    this.setState({ referenceDate: nextProps.referenceDate }, () =>
      this.handleDateChange(this.state.referenceDate, nextProps.timeBarViewType)
    )
  }

  handleDateChange(referenceDate: IDate, timeBarViewType: TimeBarViewType) {
    this.setState({ referenceDate })
    if (timeBarViewType === "week") {
      const scheduleWeek = timeHelper.getWeekRange(this.props.startDayOfWeek, moment(referenceDate).format())
      this.props.handleChangeTimeRange(scheduleWeek.startDate, scheduleWeek.endDate)
    }
    else {
      this.props.handleChangeTimeRange(moment(referenceDate).startOf("month").format(), moment(referenceDate).endOf("month").format())
    }
  }

  getStyleLabel(_button: ActiveTimeButton) {
    return this.buttonIsActive(_button) ? Object.assign({}, styles.label, styles.activeLabel) : styles.label
  }

  getStyleBtn(_button: ActiveTimeButton) {
    return this.buttonIsActive(_button) ? Object.assign({}, styles.btn, styles.activeBtn) : styles.btn
  }

  buttonIsActive(_button: ActiveTimeButton): boolean {
    return timeHelper.getActiveButton(this.props.startDayOfWeek, this.state.referenceDate, this.props.timeBarViewType) === _button
  }

  render() {
    const weekRange = timeHelper.getWeekRange(this.props.startDayOfWeek, moment(this.state.referenceDate).format())
    return (
      <div style={{ padding: 5 }} id="TimeActionBar">
        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
          <div style={{ display: "flex", marginLeft: 30 }}>
            <div style={{ marginTop: 27, width: 320, display: "flex" }} id="TimeActionBarDateArrow">
              <i
                data-intercom-target={"CalendarFilter-ArrowBtn-PreviousMonth"}
                className="fa fa-arrow-circle-left TimeActionBarArrow"
                onClick={() => this.handleDateChange(moment(this.state.referenceDate).subtract(1, this.props.timeBarViewType).toDate(), this.props.timeBarViewType)}
              />
              <span
                id="TimeActionBarDate"
                style={{ fontSize: 15, marginLeft: 5, marginRight: 5, display: "inline-block", width: 275, textAlign: "center", marginTop: -5 }}
              >
                {this.props.timeBarViewType === "week" ?
                  <span>{moment(weekRange.startDate).format("ddd MMM. DD, YYYY")} &mdash; {moment(weekRange.endDate).format("ddd MMM. DD, YYYY")}</span> :
                  <span>{moment(this.state.referenceDate).format("MMMM YYYY")}</span>
                }
              </span>
              <i
                data-intercom-target={"CalendarFilter-ArrowBtn-NextMonth"}
                className="fa fa-arrow-circle-right TimeActionBarArrow"
                onClick={() => this.handleDateChange(moment(this.state.referenceDate).add(1, this.props.timeBarViewType).toDate(), this.props.timeBarViewType)}
              />
            </div>
            <div style={{ marginLeft: 20, display: "flex" }}>
              {!this.props.hideLastThisNextButton && [
                <div key="last">
                  <RaisedButton
                    data-intercom-target={"CalendarFilter-Btn-LastMonth"}
                    label={this.props.timeBarViewType === "week" ? strings.Last_Week.toUpperCase() : strings.Last_Month.toUpperCase()}
                    style={{ marginRight: 5 }}
                    onTouchTap={() => this.handleDateChange(moment().subtract(1, this.props.timeBarViewType).toDate(), this.props.timeBarViewType)}
                    labelStyle={this.getStyleLabel("last")}
                    buttonStyle={this.getStyleBtn("last")}
                  />
                </div>,
                <div key="this">
                  <RaisedButton
                    data-intercom-target={"CalendarFilter-Btn-ThisMonth"}
                    label={this.props.timeBarViewType === "week" ? strings.This_Week.toUpperCase() : strings.This_Month.toUpperCase()}
                    style={{ marginRight: 5 }}
                    onTouchTap={() => this.handleDateChange(new Date(), this.props.timeBarViewType)}
                    labelStyle={this.getStyleLabel("this")}
                    buttonStyle={this.getStyleBtn("this")}
                  />
                </div>,
                <div key="next">
                  <RaisedButton
                    data-intercom-target={"CalendarFilter-Btn-NextMonth"}
                    label={this.props.timeBarViewType === "week" ? strings.Next_Week.toUpperCase() : strings.Next_Month.toUpperCase()}
                    style={{ marginRight: 5 }}
                    onTouchTap={() => this.handleDateChange(moment().add(1, this.props.timeBarViewType).toDate(), this.props.timeBarViewType)}
                    labelStyle={this.getStyleLabel("next")}
                    buttonStyle={this.getStyleBtn("next")}
                  />
                </div>
              ]}
              <IconButton data-intercom-target={"CalendarFilter-Btn-OpenDatePicker"} onTouchTap={() => this.FinddDatePicker.DatePicker.openDialog()} tooltip={"Pick a date"}>
                <FontIcon className={"fa fa-calendar fa-lg"} />
              </IconButton>
              <div>
                <FinddDatePicker
                  ref={(elem) => (this.FinddDatePicker = elem)}
                  id={"dp-text-field"}
                  textFieldStyle={{ display: "none" }}
                  value={moment(this.state.referenceDate).toDate()}
                  onChange={(_, date: Date) => this.handleDateChange(date, this.props.timeBarViewType)}
                  cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                  firstDayOfWeek={0}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
